import { graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Accordion from "./Accordion"
import * as css from "./FAQ.module.css"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"

function FAQ({ label, heading, content }) {
  return (
    <Section>
      {heading && (
        <SimpleHeader
          label={label}
          title={heading}
          dash="vertical"
          narrow="both"
        />
      )}
      {content?.sections?.map((section, sectionIndex) => (
        <div className={css.section} key={sectionIndex}>
          {section.title && (
            <div className={css.sectionTitle}>{section.title}</div>
          )}
          {section.faqs && <Accordion faqs={section.faqs} />}
        </div>
      ))}
    </Section>
  )
}

FAQ.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  content: PropTypes.object,
}

export default FAQ

export const query = graphql`
  fragment FAQ on ContentfulFaq {
    id
    __typename
    label
    heading
    content {
      sections {
        title
        faqs {
          question
          answer
        }
      }
    }
  }
`
